<template>
  <div class="debt-receipt-settings">
    <div class="row">
      <div class="col-md-6">
        <div class="card shadow-sm border-0 mb-4">
          <div class="card-header bg-white font-weight-bold p-3">
            <i class="fas fa-print text-primary mr-2"></i> Cấu hình in Phiếu Biên Nhận / Thanh Toán
          </div>
          <div class="card-body">
            <div class="form-group mb-4">
              <label class="font-weight-bold d-flex align-items-center justify-content-between cursor-pointer" @click="localData.autoPrint = !localData.autoPrint; save()">
                <span>Tự động in sau khi thanh toán</span>
                <van-switch v-model="localData.autoPrint" size="24px" @change="save" />
              </label>
              <small class="text-muted">Hệ thống sẽ tự động bật cửa sổ in sau khi nút Xác nhận thanh toán màn hình công nợ được bấm.</small>
            </div>
            
            <div class="form-group">
              <label class="font-weight-bold">Số bản in mỗi lần</label>
              <van-stepper v-model="localData.printCopies" min="1" max="5" @change="save" />
            </div>

            <div class="form-group">
              <label class="font-weight-bold">Tiêu đề phiếu in</label>
              <input type="text" class="form-control" v-model="localData.title" @change="save" placeholder="Ví dụ: PHIẾU BIÊN NHẬN THANH TOÁN">
            </div>

            <div class="form-group">
              <label class="font-weight-bold">Tiêu đề phiếu báo nợ hiện tại</label>
              <input type="text" class="form-control" v-model="localData.currentDebtTitle" @change="save" placeholder="Ví dụ: PHIẾU BÁO CÔNG NỢ">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm border-0 mb-4">
          <div class="card-header bg-white font-weight-bold p-3">
            <i class="fas fa-print text-success mr-2"></i> Cấu hình in Phiếu Thu / Chi
          </div>
          <div class="card-body">
            <div class="form-group mb-4">
              <label class="font-weight-bold d-flex align-items-center justify-content-between cursor-pointer" @click="localTransData.autoPrint = !localTransData.autoPrint; saveTrans()">
                <span>Tự động in sau khi tạo phiếu</span>
                <van-switch v-model="localTransData.autoPrint" size="24px" @change="saveTrans" />
              </label>
              <small class="text-muted">Hệ thống sẽ tự động bật cửa sổ in sau khi tạo Phiếu Thu / Chi thành công.</small>
            </div>
            
            <div class="form-group">
              <label class="font-weight-bold">Số bản in mỗi lần</label>
              <van-stepper v-model="localTransData.printCopies" min="1" max="5" @change="saveTrans" />
            </div>

            <div class="form-group">
              <label class="font-weight-bold">Tiêu đề Phiếu Thu (+)</label>
              <input type="text" class="form-control" v-model="localTransData.incomeTitle" @change="saveTrans" placeholder="Ví dụ: PHIẾU THU">
            </div>

            <div class="form-group">
              <label class="font-weight-bold">Tiêu đề Phiếu Chi (-)</label>
              <input type="text" class="form-control" v-model="localTransData.expenseTitle" @change="saveTrans" placeholder="Ví dụ: PHIẾU CHI">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebtReceiptSettings',
  props: {
    data: {
      type: Object,
      required: true
    },
    transData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localData: {},
      localTransData: {}
    }
  },
  created() {
    this.localData = JSON.parse(JSON.stringify(this.data))
    this.localTransData = JSON.parse(JSON.stringify(this.transData))
  },
  methods: {
    save() {
      this.$emit('update', 'debtReceipt', this.localData)
    },
    saveTrans() {
      this.$emit('update', 'transactionReceipt', this.localTransData)
    }
  },
  watch: {
    data: {
      handler(newVal) {
        this.localData = JSON.parse(JSON.stringify(newVal))
      },
      deep: true
    },
    transData: {
      handler(newVal) {
        this.localTransData = JSON.parse(JSON.stringify(newVal))
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
